import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import StationLink from '../StationLink/StationLink';

export interface NearestForecastMessageProps {
  chartLabel: string;
  locationName: string;
  nearestStationName: string;
  distanceKm: number;
  onNearestStationClick: () => void;
}

const NearestForecastMessage: FC<NearestForecastMessageProps> = ({
  chartLabel,
  locationName,
  nearestStationName,
  distanceKm,
  onNearestStationClick,
}) => {
  const chartType = chartLabel.toLowerCase();

  return (
    <Box fontSize={1} lineHeight="1.5">
      {`No ${chartType} is recorded at ${locationName}. The nearest ${chartType} forecast is at `}
      <StationLink
        color="primary"
        name={nearestStationName}
        onClick={onNearestStationClick}
      />
      {` (${distanceKm.toFixed(1)}km away).`}
    </Box>
  );
};

export default NearestForecastMessage;
